import React from 'react'

const QuestionCompleted = (props) => {
  return (
    <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.83325 10.8334H11.6666"
      stroke="#22C55E"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16667 2.5H5C3.61929 2.5 2.5 3.61929 2.5 5V12.5C2.5 13.8807 3.61929 15 5 15H6.6725V17.0357C6.6725 17.2139 6.77461 17.3763 6.93517 17.4534C7.09573 17.5306 7.2863 17.5089 7.42541 17.3976L10.4225 15H15C16.3807 15 17.5 13.8807 17.5 12.5V10.8333"
      stroke="#22C55E"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83325 7.49998H8.33325"
      stroke="#22C55E"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3334 5.80865C18.3334 6.17684 18.0349 6.47532 17.6667 6.47532H16.3334V7.80865C16.3334 8.17684 16.0349 8.47532 15.6667 8.47532H14.3334C13.9652 8.47532 13.6667 8.17684 13.6667 7.80865V6.47532H12.3334C11.9652 6.47532 11.6667 6.17684 11.6667 5.80865V4.47532C11.6667 4.10713 11.9652 3.80865 12.3334 3.80865H13.6667V2.47532C13.6667 2.10713 13.9652 1.80865 14.3334 1.80865H15.6667C16.0349 1.80865 16.3334 2.10713 16.3334 2.47532V3.80865H17.6667C18.0349 3.80865 18.3334 4.10713 18.3334 4.47532V5.80865Z"
      stroke="#22C55E"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  )
}

export default QuestionCompleted